import { render, staticRenderFns } from "./paperwork.vue?vue&type=template&id=bbe1486a&scoped=true"
import script from "./paperwork.vue?vue&type=script&lang=js"
export * from "./paperwork.vue?vue&type=script&lang=js"
import style0 from "./paperwork.vue?vue&type=style&index=0&id=bbe1486a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbe1486a",
  null
  
)

export default component.exports